module.exports = __webpack_public_path__ + "48dcc07e00198f7d3607d069864aa19d.pdf";